import styled from 'styled-components';

import { COLORS, NOT_FOUND_GLOW, NOT_FOUND_NUMERAL_GRADIENT } from '../../theme/tokens';
import { Text } from '../../components';

export const Root = styled.div`
  position: relative;
  flex: 1;
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const Glow = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(140%, 900px);
  height: 480px;
  transform: translate(-50%, -50%);
  background: ${NOT_FOUND_GLOW};
  filter: blur(6px);
  pointer-events: none;
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
  max-width: 460px;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const Numeral = styled.p`
  margin: 0;
  font-size: clamp(72px, 14vw, 140px);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.01em;
  background: ${NOT_FOUND_NUMERAL_GRADIENT};
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const Heading = styled(Text)`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: ${COLORS.textStrong};
`;

export const Subtitle = styled(Text)`
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: ${COLORS.textMuted};
`;

export const Actions = styled.div`
  display: flex;
  gap: 14px;
`;
